<template>
  <div>
    <div ref="map" class="msu-map" :aria-label="$t('Карта органов МСУ')"></div>
    <v-alert v-if="items.length === 0" type="info" outlined class="mt-4">
      {{ $t('Для выбранных органов координаты пока не заполнены') }}
    </v-alert>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow
})

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    map: null,
    markers: []
  }),
  watch: {
    items() {
      this.renderMarkers()
    }
  },
  mounted() {
    this.map = L.map(this.$refs.map).setView([41.2, 74.7], 7)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 18
    }).addTo(this.map)
    this.renderMarkers()
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove()
    }
  },
  methods: {
    renderMarkers() {
      if (!this.map) return
      this.markers.forEach(marker => marker.remove())
      this.markers = this.items.map(item => {
        const marker = L.marker([item.latitude, item.longitude])
          .addTo(this.map)
          .bindTooltip(item.name)
        marker.on('click', () => {
          this.$router.push(this.$i18nRoute({ name: 'msu-authority', params: { id: item.id } }))
        })
        return marker
      })
      if (this.markers.length > 0) {
        this.map.fitBounds(L.featureGroup(this.markers).getBounds().pad(0.15), { maxZoom: 12 })
      }
    }
  }
}
</script>

<style scoped>
.msu-map {
  width: 100%;
  height: 520px;
  border: 1px solid #e1e1e1;
  z-index: 1;
}
</style>
